<template>
  <div class="news_details">
    <div class="details_title">
      系统通知
    </div>
    <div class="details_time">
      {{ detailse.checkTime }}
    </div>
    <div class="details_content">
      {{ detailse.content }}
    </div>
  </div>
</template>

<script>
import { getSMSReadReacordById } from '@api/businessInformation/index'
export default {
  data() {
    return {
      detailse: {}
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.detailsNews(this.$route.query.id)
    }
  },
  methods: {
    detailsNews(e) {
      getSMSReadReacordById({ id: e }).then(res => {
        this.detailse = res.data.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.news_details {
  text-align: center;
  .details_title {
    color: rgba(51, 51, 51, 100);
    font-size: 18px;
    margin-top: 15px;
  }
  .details_time {
    font-size: 14px;
    margin: 20px 0;
  }
  .details_content {
    padding: 20px;
    font-size: 14px;
    text-align: left;
    line-height: 20px;
    letter-spacing: 2px;
    border-top: 1px solid rgba(5, 27, 59, 0.1);
  }
}
</style>
